import { DateTimeParameter } from '@drivingdoc/shared-types/reports';
import Grid from '@mui/material/Grid';

import DateTimeInput from 'components/Forms/DateTimeInput';

import { calculateDateFromOffset } from 'utils/reportParameters';

import { resolveMaxDate } from './resolveMaxDate';

interface DateTimeParameterFieldProps {
  parameter: DateTimeParameter;
}

export default function DateTimeParameterField({ parameter }: DateTimeParameterFieldProps) {
  const { config } = parameter;
  const minDate = config?.minDateOffset ? calculateDateFromOffset(config.minDateOffset) : undefined;
  const maxDate = resolveMaxDate(config?.maxDateOffset, config?.allowFutureDates);

  return (
    <Grid size={12}>
      <DateTimeInput name={parameter.name} label={parameter.label} minDate={minDate} maxDate={maxDate} />
    </Grid>
  );
}
